import { z } from 'zod';

export const Vertical = z.enum(['CAFE', 'FASTFOOD', 'SHOP', 'SALON', 'BILLIARD']);
export type Vertical = z.infer<typeof Vertical>;

export const Features = z.object({
  kitchen: z.boolean(),
  tables: z.boolean(),
  courses: z.boolean(),
});
export type Features = z.infer<typeof Features>;

export const AccountProfile = z.object({
  name: z.string(),
  vertical: Vertical,
  features: Features,
  /** формат бизнеса меняет только владелец */
  isOwner: z.boolean(),
  /** Сбор за обслуживание: касса берёт правило отсюда, а не из своей копии */
  service: z.object({
    percent: z.number().int().min(0).max(30),
    dineInOnly: z.boolean(),
    fromGuests: z.number().int().min(0),
  }).optional(),
  /** права этого человека: офис прячет вкладки, которых ему не открыть */
  permissions: z.record(z.string(), z.string()).default({}),
});

export const PatchProfile = z.object({ vertical: Vertical });
export type PatchProfile = z.infer<typeof PatchProfile>;
export type AccountProfile = z.infer<typeof AccountProfile>;
